// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const InfoBoxWithCallout: MarkdocTagRegistration = {
  tag: 'info-box-with-callout',
  component: 'InfoBoxWithCallout',
  children: ['info-item'],
  attributes: {
    callout: {
      type: String,
      required: true,
      description: 'This is the callout content.',
      localizable: true,
    },
    icon: {
      type: String,
      required: false,
      description:
        'Pass in an Sail icon that is shown in the callout. (View go/sail/Icon).',
    },
  },
};
